import FeedLayout from "layouts/files/FeedLayout";
import { Link } from "react-router-dom";
import { BlockMember, Button, SVG } from "ui";

import { usersArray } from "assets/data/usersData";

const BlockUsers = () => {
    const members = usersArray.filter((member, i) => {
        if (i % 2) {
            return member;
        }
    });
    return (
        <FeedLayout pageTitle="Settings">
            <div className="settings-page">
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <Link to="/settings/prefrence">
                        <SVG svg="chevron-left" size={24} />
                    </Link>
                    <h1 className="fw-700 fs-12em">Block Users</h1>
                    <div></div>
                </div>

                <div className="profile-followers-div">
                    <div className="profile-followers-card card mt-20">
                        <div
                            className={` profile-followers-container pt-20 pl-20 pr-20 pb-20 d-flex flex-col flex-j-between`}
                        >
                            <div>
                                {members.map((member) => (
                                    <BlockMember
                                        user={member}
                                        key={member.id}
                                        className="mb-20"
                                    />
                                ))}
                            </div>
                            <div className="mb-10 d-flex flex-j-center  w-full">
                                <Button text="show More" color="" rounded />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </FeedLayout>
    );
};

export default BlockUsers;
